import React from 'react';
import styles from './Testimonials.module.css';
import Card from '../UI/Card';

const Testimonials = () => {
    const testimonials = [
        {
        id: 1,
        quote: "Their team delivered exceptional results that exceeded our expectations. The website performance improved dramatically.",
        author: "Sarah Johnson",
        position: "Marketing Director, TechCorp"
        },
        {
        id: 2,
        quote: "Professional, reliable, and incredibly talented. They transformed our digital presence completely.",
        author: "Michael Chen",
        position: "CEO, StartupXYZ"
        },
        {
        id: 3,
        quote: "The attention to detail and commitment to quality is outstanding. A true partnership experience.",
        author: "Emily Rodriguez",
        position: "Product Manager, GrowthCo"
        }
    ];

    return (
        <section className={styles.testimonials}>
            <div className={styles.container}>
                <div className={styles.sectionHeader}>
                    <h2>What Our Clients Say</h2>
                    <p>Don't just take our word for it - hear from our satisfied clients.</p>
                </div>
                
                <div className={styles.testimonialsGrid}>
                    {testimonials.map((testimonial) => (
                        <Card 
                        key={testimonial.id} 
                        variant="ghost" 
                        padding="large"
                        className={styles.testimonialCard}
                        >
                            <div className={styles.quoteIcon}>❝</div>
                            <p className={styles.quote}>{testimonial.quote}</p>
                            <div className={styles.author}>
                                <div className={styles.authorName}>{testimonial.author}</div>
                                <div className={styles.authorDetails}>{testimonial.position}</div>
                            </div>
                        </Card>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;